import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component'
import { ProjectDbRecordsComponent } from './project-db-records/project-db-records.component';
import { AdminPageComponent } from './admin-page/admin-page.component'
import { UsersDashboardComponent } from './users-dashboard/users-dashboard.component';


const appRoutes: Routes = [
  {
    path: 'projects',
    component: ProjectDashboardComponent
  },
  {
    path: 'project/:id/dbRecords',
    component: ProjectDbRecordsComponent
  },
  {
    path: 'admin/users',
    component: UsersDashboardComponent
  },
  {
    path: 'admin/:tp',
    component: AdminPageComponent
  },
  {
    path: 'admin/:tp/:id',
    component: AdminPageComponent
  },
  {
    path: '**',
    redirectTo: 'projects',
  },
];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/app.routing.ts